/**
 * 描述：产品管理指令
 * 日期：2017-9-13
 * 作者：Bai.Zhiming
 */
angular.module("productManageMentDirModule",["popoverModule","trsGroupOpenModule","newspaperNavModule"]);